"use strict";
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOTNET_INSTALL_MODE_LIST = void 0;
exports.DOTNET_INSTALL_MODE_LIST = ['sdk', 'runtime', 'aspnetcore'];
//# sourceMappingURL=DotnetInstallMode.js.map